import { createSelector } from 'reselect';

const selectVehicles = (state: any) => state.vehicles;


export const selectVehiclesCurrentItem = createSelector([selectVehicles], (vehicles) => vehicles.current);

export const selectVehiclesListItems = createSelector([selectVehicles], (vehicles) => vehicles.list);

export const selectVehiclesItemById = (itemId: any) =>
    createSelector(selectVehiclesListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectVehiclesQueryItems = createSelector([selectVehicles], (vehicles) => vehicles.query);

export const selectVehiclesCreatedItem = createSelector([selectVehicles], (vehicles) => vehicles.create);

export const selectVehiclesUpdatedItem = createSelector([selectVehicles], (vehicles) => vehicles.update);

export const selectVehiclesReadItem = createSelector([selectVehicles], (vehicles) => vehicles.read);

export const selectVehiclesDeletedItem = createSelector([selectVehicles], (vehicles) => vehicles.delete);

export const selectVehiclesSearchedItems = createSelector([selectVehicles], (vehicles) => vehicles.search);

export const selectVehiclesItemsCount = createSelector([selectVehicles], (vehicles) => vehicles.count);

export const selectVehiclesItemsFilter = createSelector([selectVehicles], (vehicles) => vehicles.filter);